export enum EducationLevel {
  LEVEL_2 = '2',
  LEVEL_3 = '3',
  LEVEL_5 = '5',
  LEVEL_6 = '6',
  LEVEL_7 = '7',
  LEVEL_8 = '8',
}

export const educationLevelMapping = {
  [EducationLevel.LEVEL_2]: $localize`:@@common_educationLevel_level2:Middle School`,
  [EducationLevel.LEVEL_3]: $localize`:@@common_educationLevel_level3:High School`,
  [EducationLevel.LEVEL_5]: $localize`:@@common_educationLevel_level5:Short term`,
  [EducationLevel.LEVEL_6]: $localize`:@@common_educationLevel_level6:College`,
  [EducationLevel.LEVEL_7]: $localize`:@@common_educationLevel_level7:MasterDegree`,
  [EducationLevel.LEVEL_8]: $localize`:@@common_educationLevel_level8:PhD`,
};
